import { Component, OnInit, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ValidateErrorLookupService } from '../../services/validate-error-lookup.service';
import { Message } from 'primeng/api/message';
import { AlertService } from 'src/app/services/AlertService';

@Component({
  selector: 'app-validateform',
  templateUrl: './validateform.component.html',
  styleUrls: ['./validateform.component.scss']
})

export class ValidateformComponent implements OnInit {

    @Input()
    formToValidate: NgForm;
    msgs: Message[];

    controlErrorMessages: any[] = [];
    formErrorMessages: any[] = [];
    showClearButton: boolean = false;

    constructor(private errorLookUp: ValidateErrorLookupService,
                private alertService: AlertService) { }

    ngOnInit() {
    }

    validateForm(): boolean {

        this.formErrorMessages = [];

        let formIsValid = true;
        let controls = Object.keys(this.formToValidate.controls);

        if (this.formToValidate.errors != null) {
            let errors = Object.keys(this.formToValidate.errors);

            errors.forEach((error) => {

                let validationError = ' ' + this.errorLookUp.getErrorMessageForValidator(error);

                this.formErrorMessages.push(validationError);

            });

        }

        this.controlErrorMessages = [];


        controls.forEach((controlName) => {


            if (this.formToValidate.controls[controlName].errors != null) {
                let errors = Object.keys(this.formToValidate.controls[controlName].errors);

                errors.forEach((error) => {

                    let controlElement = document.getElementsByName(controlName)[0];

                    let displayName = controlElement.dataset.displayName;

                    if (!displayName) {
                        displayName = controlElement.parentElement.parentElement.parentElement.dataset.displayName;
                    }

                    let validationError = displayName + ' ' + this.errorLookUp.getErrorMessageForValidator(error);

                    this.controlErrorMessages.push(validationError);

                });
            }

        });

        if (this.formErrorMessages.length > 0 || this.controlErrorMessages.length > 0) {
            formIsValid = false;

            if (this.formErrorMessages.length + this.controlErrorMessages.length > 1)
                this.showClearButton = true;
        }
        this.SetMessage('warn', this.formErrorMessages);
        this.SetMessage('warn', this.controlErrorMessages);

        return formIsValid;

    }

    SetMessage(type: any, errors: any[]) {
        this.msgs = [];
        for (var err of errors) {
            this.msgs.push({ severity: type, summary: '', detail: err });
        }        
    }

    public resetForm() {
        //this.formToValidate.resetForm();
        this.controlErrorMessages = [];
        this.formErrorMessages = [];        
    }

}
